import React from "react";
import { BRAND } from "@/lib/config";
import { Sparkles, Clock } from "lucide-react";

export default function MaintenancePage({ settings, isAdmin, onOpenSite }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6 relative overflow-hidden">
      {/* Ambient orange/pink glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-[#FF8A00]/20 blur-[160px]" />
        <div className="absolute bottom-1/4 -right-40 w-[500px] h-[500px] rounded-full bg-[#E52E71]/15 blur-[140px]" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full border border-[#FF8A00]/5 opacity-40" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[1100px] rounded-full border border-[#FF8A00]/5 opacity-30" />
      </div>

      <div className="max-w-2xl w-full text-center relative z-10">
        <div className="flex items-center justify-center gap-3 mb-10 fade-up">
          <img src={BRAND.logo} alt="Dr Thrive 365"
            className="h-14 w-14 rounded-xl object-cover ring-glow" />
          <div className="text-left">
            <div className="font-display text-2xl leading-none">Dr Thrive 365</div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mt-1">Rewire · Restore</div>
          </div>
        </div>

        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#FF8A00]/10 border border-[#FF8A00]/25 text-[11px] tracking-[0.25em] uppercase text-[#FF8A00] fade-up delay-1">
          <span className="w-1.5 h-1.5 rounded-full bg-[#FF8A00] animate-pulse" />
          Under Construction
        </div>

        <h1 className="font-display text-5xl sm:text-7xl leading-[0.95] mt-8 fade-up delay-2">
          <span className="text-brand-gradient">{settings.maintenance_title || "We're rewiring the lab."}</span>
        </h1>

        <p className="text-lg text-white/60 mt-6 max-w-lg mx-auto leading-relaxed fade-up delay-3">
          {settings.maintenance_message || "Dr. Slava is uploading new protocols. We'll be back online shortly."}
        </p>

        {settings.maintenance_eta && (
          <div className="inline-flex items-center gap-2 mt-8 px-5 py-2.5 rounded-full glass fade-up delay-4">
            <Clock size={14} className="text-[#FF8A00]" />
            <span className="text-sm text-white/80">{settings.maintenance_eta}</span>
          </div>
        )}

        <div className="mt-14 fade-up delay-5">
          {isAdmin ? (
            <button
              onClick={onOpenSite}
              data-testid="admin-bypass-maintenance"
              className="text-[11px] tracking-[0.28em] uppercase text-[#FF8A00] hover:text-white transition-colors"
            >
              <Sparkles size={12} className="inline mr-2" />
              Admin — enter site anyway
            </button>
          ) : (
            <p className="text-[11px] tracking-[0.28em] uppercase text-white/30">
              Check back soon
            </p>
          )}
        </div>

        <div className="mt-24 pt-6 border-t border-white/5 text-[10px] text-white/25 fade-up delay-5">
          This content is for educational purposes only and not medical advice.
        </div>
      </div>
    </div>
  );
}
